// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceValueDateTime
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceBaseValue } from "abweb/dto/ds/DataSourceBaseValue";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceSaveAction } from "abweb/dto/generated/ds/DataSourceSaveAction";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
export class DataSourceValueDateTimeBase extends DataSourceBaseValue {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceValueDateTimeBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceValueDateTime";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceValueDateTime(json.attributeValues != null ? json.attributeValues : null, json.clientTag != null ? json.clientTag : null, json.dataSourceSaveAction != null ? DataSourceSaveAction.fromJson(json.dataSourceSaveAction) : null, json.editableOverwrite != null ? json.editableOverwrite : null, json.id != null ? json.id : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.baselineRefID != null ? json.baselineRefID : null, json.fieldTypeOverwrite != null ? DataFieldTypeEnum.fromJson(json.fieldTypeOverwrite) : null, json.refID != null ? json.refID : null, json.baseline != null ? new Date(json.baseline) : null, json.currentValue != null ? new Date(json.currentValue) : null, json.value != null ? new Date(json.value) : null);
  }
  initDataSourceValueDateTime(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value) {
    this.initDataSourceBaseValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID);
    this._baseline = baseline;
    this._currentValue = currentValue;
    this._value = value;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._baseline != null) {
      retVal["baseline"] = this._baseline;
    }
    if (this._currentValue != null) {
      retVal["currentValue"] = this._currentValue;
    }
    if (this._value != null) {
      retVal["value"] = this._value;
    }
    return retVal;
  }
  get baseline() {
    return this._baseline;
  }
  set baseline(value) {
    this._baseline = value;
  }
  get currentValue() {
    return this._currentValue;
  }
  set currentValue(value) {
    this._currentValue = value;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
//# sourceMappingURL=DataSourceValueDateTimeBase.js.map
